export const imageMissingUrl = 'https://neu.s201901.cloud.shopingo.de/real/user/no-image.svg';
export const imagePrefixUrl = 'https://s201901.cloud.shopingo.de/th_a/300_300_widthscale_ffffff_';
export const imageDefaultScaling = '300_300_widthscale_ffffff_';